import React from "react";
import { IAddSessionFormData } from "./AddSessionForm";
import { ISessionErrors } from "./AddSessionValidate";

export const AddSessionFormContext = React.createContext<{
    formData: IAddSessionFormData,
    setFormData: React.Dispatch<React.SetStateAction<IAddSessionFormData>>,
    errors: ISessionErrors,
    setErrors: React.Dispatch<React.SetStateAction<ISessionErrors>>,
    saveSession: ()=>void,
    deleteSession: ()=>void,
    editId: string;
    //setEditId: React.Dispatch<React.SetStateAction<string>>;
}>({
    editId: null,
    //setEditId: null,
    formData: null,
    setFormData: null,
    errors: null,
    setErrors: null,
    saveSession: null,
    deleteSession: null
})